import { combineReducers } from "redux";
import projects from './projects'
import login from './login'
import lecturerprojects from "./lecturerprojects";
import dates from "./dates"

export default combineReducers({
    projects, login, lecturerprojects, dates
});